var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _handleClick, _handleChange, _button, _listbox, _listboxSlot, _expanded, _handleClick_, handleClick__fn, _handleChange_, handleChange__fn, _toggle, toggle_fn, _toggleExpanded, toggleExpanded_fn;
import "../media-chrome-button.js";
import "./media-chrome-listbox.js";
import { window, document } from "../utils/server-safe-globals.js";
import { MediaStateReceiverAttributes } from "../constants.js";
const template = document.createElement("template");
template.innerHTML = `
  <style>
  :host {
    display: inline-block;
  }

  media-chrome-button:not(:focus-visible) {
    outline: none;
  }
  </style>

  <media-chrome-button aria-haspopup="listbox">
    <slot name="button-content"></slot>
  </media-chrome-button>
  <slot name="listbox" hidden>
    <media-chrome-listbox id="listbox" part="listbox">
      <slot></slot>
    </media-chrome-listbox>
  </slot>
`;
class MediaChromeMenuButton extends window.HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _handleClick_);
    __privateAdd(this, _handleChange_);
    __privateAdd(this, _toggle);
    __privateAdd(this, _toggleExpanded);
    __privateAdd(this, _handleClick, void 0);
    __privateAdd(this, _handleChange, void 0);
    __privateAdd(this, _button, void 0);
    __privateAdd(this, _listbox, void 0);
    __privateAdd(this, _listboxSlot, void 0);
    __privateAdd(this, _expanded, false);
    const shadow = this.attachShadow({ mode: "open" });
    const buttonHTML = template.content.cloneNode(true);
    this.nativeEl = buttonHTML;
    shadow.appendChild(buttonHTML);
    __privateSet(this, _handleClick, __privateMethod(this, _handleClick_, handleClick__fn).bind(this));
    __privateSet(this, _handleChange, __privateMethod(this, _handleChange_, handleChange__fn).bind(this));
    __privateSet(this, _button, this.shadowRoot.querySelector("media-chrome-button"));
    __privateSet(this, _listbox, this.shadowRoot.querySelector("media-chrome-listbox"));
    __privateSet(this, _listboxSlot, this.shadowRoot.querySelector("slot[name=listbox]"));
    __privateGet(this, _listboxSlot).addEventListener("slotchange", () => {
      __privateGet(this, _listbox).removeEventListener("change", __privateGet(this, _handleChange));
      __privateSet(this, _listbox, __privateGet(this, _listboxSlot).assignedElements()[0] || __privateGet(this, _listbox));
      __privateGet(this, _listbox).addEventListener("change", __privateGet(this, _handleChange));
    });
  }
  static get observedAttributes() {
    return [
      "disabled",
      MediaStateReceiverAttributes.MEDIA_CONTROLLER
    ];
  }
  enable() {
    __privateGet(this, _button).removeAttribute("disabled");
    __privateGet(this, _button).handleClick = __privateGet(this, _handleClick);
    __privateMethod(this, _toggleExpanded, toggleExpanded_fn).call(this);
    __privateGet(this, _listbox).addEventListener("change", __privateGet(this, _handleChange));
  }
  disable() {
    __privateGet(this, _button).setAttribute("disabled", "");
    __privateGet(this, _button).handleClick = () => {
    };
    __privateGet(this, _listbox).addEventListener("change", __privateGet(this, _handleChange));
  }
  attributeChangedCallback(attrName, oldValue, newValue) {
    var _a, _b;
    if (attrName === MediaStateReceiverAttributes.MEDIA_CONTROLLER) {
      if (oldValue) {
        const mediaControllerEl = document.getElementById(oldValue);
        (_a = mediaControllerEl == null ? void 0 : mediaControllerEl.unassociateElement) == null ? void 0 : _a.call(mediaControllerEl, this);
        __privateGet(this, _listbox).removeAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);
      }
      if (newValue) {
        const mediaControllerEl = document.getElementById(newValue);
        (_b = mediaControllerEl == null ? void 0 : mediaControllerEl.associateElement) == null ? void 0 : _b.call(mediaControllerEl, this);
        __privateGet(this, _listbox).setAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER, newValue);
      }
    } else if (attrName === "disabled" && newValue !== oldValue) {
      if (newValue == null) {
        this.enable();
      } else {
        this.disable();
      }
    }
  }
  connectedCallback() {
    var _a;
    if (!this.hasAttribute("disabled")) {
      this.enable();
    }
    const mediaControllerId = this.getAttribute(
      MediaStateReceiverAttributes.MEDIA_CONTROLLER
    );
    if (mediaControllerId) {
      const mediaControllerEl = document.getElementById(mediaControllerId);
      (_a = mediaControllerEl == null ? void 0 : mediaControllerEl.associateElement) == null ? void 0 : _a.call(mediaControllerEl, this);
      __privateGet(this, _listbox).setAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER, mediaControllerId);
    }
  }
  disconnectedCallback() {
    var _a;
    this.disable();
    const mediaControllerId = this.getAttribute(
      MediaStateReceiverAttributes.MEDIA_CONTROLLER
    );
    if (mediaControllerId) {
      const mediaControllerEl = document.getElementById(mediaControllerId);
      (_a = mediaControllerEl == null ? void 0 : mediaControllerEl.unassociateElement) == null ? void 0 : _a.call(mediaControllerEl, this);
      __privateGet(this, _listbox).removeAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);
    }
  }
}
_handleClick = new WeakMap();
_handleChange = new WeakMap();
_button = new WeakMap();
_listbox = new WeakMap();
_listboxSlot = new WeakMap();
_expanded = new WeakMap();
_handleClick_ = new WeakSet();
handleClick__fn = function() {
  __privateMethod(this, _toggle, toggle_fn).call(this);
};
_handleChange_ = new WeakSet();
handleChange__fn = function() {
  __privateMethod(this, _toggle, toggle_fn).call(this);
};
_toggle = new WeakSet();
toggle_fn = function() {
  __privateGet(this, _listboxSlot).hidden = !__privateGet(this, _listboxSlot).hidden;
  __privateMethod(this, _toggleExpanded, toggleExpanded_fn).call(this);
  if (!__privateGet(this, _listboxSlot).hidden) {
    __privateGet(this, _listbox).focus();
  } else {
    __privateGet(this, _button).focus();
  }
};
_toggleExpanded = new WeakSet();
toggleExpanded_fn = function() {
  __privateGet(this, _button).setAttribute("aria-expanded", __privateGet(this, _expanded));
  __privateSet(this, _expanded, !__privateGet(this, _expanded));
};
if (!window.customElements.get("media-chrome-menu-button")) {
  window.customElements.define("media-chrome-menu-button", MediaChromeMenuButton);
}
var media_chrome_menu_button_default = MediaChromeMenuButton;
export {
  media_chrome_menu_button_default as default
};
